import axios from "axios"

// Backend base URL.
// Production default; override per-environment with REACT_APP_API_BASE_URL
// (create-react-app exposes any REACT_APP_* var to the browser).
export const BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://api.mediiq.app"
export const TOKEN_EXPIRED_EVENT = "gestock:token-expired"
// export const BASE_URL = "http://192.168.1.4:8080"
// export const BASE_URL = "http://localhost:8080"

let hasPendingSessionExpiryEvent = false

const shouldTriggerSessionExpiry = (error) => {
  const status = error?.response?.status
  const message = String(
    error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      ""
  ).toLowerCase()

  if (status === 401) return true

  return (
    message.includes("token") &&
    (message.includes("expired") ||
      message.includes("invalid") ||
      message.includes("jwt") ||
      message.includes("unauthorized"))
  )
}

const notifyTokenExpired = () => {
  if (hasPendingSessionExpiryEvent || typeof window === "undefined") return

  hasPendingSessionExpiryEvent = true
  window.dispatchEvent(new CustomEvent(TOKEN_EXPIRED_EVENT))
}

export const resetTokenExpiredState = () => {
  hasPendingSessionExpiryEvent = false
}

const apiClient = axios.create({
  baseURL: `${BASE_URL}/api/`,
  headers: {
    "Content-Type": "application/json",
  },
})

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (shouldTriggerSessionExpiry(error)) {
      notifyTokenExpired()
    }

    return Promise.reject(error)
  }
)

export default apiClient
